import * as Sentry from "@sentry/react";
/**
 * WI #8534: centralizes the `Sentry.withScope` + setTag pattern so all
 * timeout / availability error paths emit consistent SearchId + IdSession
 * tags. Previously `withTimeout.ts` passed tags inline via the
 * `captureMessage` options object — that produces tags as event metadata
 * but does NOT add them as top-level Sentry searchable tags. Tests in
 * `*.timeout.test.js` already expect `Sentry.withScope` and break against
 * the old inline form.
 *
 * Fallback chain:
 *   SearchId  ← extraTags.SearchId  ?? sessionStorage["searchId"]  ?? ""
 *   IdSession ← extraTags.IdSession ?? sessionStorage["idSession"] ??
 *               sessionStorage["guid"] ?? ""
 *
 * Empty/undefined tags are skipped so Sentry does not record meaningless
 * `setTag("X", "")` calls.
 */
export function captureWithSearchContext(message, level, extraTags) {
    Sentry.withScope((scope) => {
        var _a, _b, _c, _d, _e;
        scope.setLevel(level);
        const searchId = (_a = extraTags === null || extraTags === void 0 ? void 0 : extraTags.SearchId) !== null && _a !== void 0 ? _a : (typeof sessionStorage !== "undefined"
            ? (_b = sessionStorage.getItem("searchId")) !== null && _b !== void 0 ? _b : ""
            : "");
        const idSession = (_c = extraTags === null || extraTags === void 0 ? void 0 : extraTags.IdSession) !== null && _c !== void 0 ? _c : (typeof sessionStorage !== "undefined"
            ? (_e = (_d = sessionStorage.getItem("idSession")) !== null && _d !== void 0 ? _d : sessionStorage.getItem("guid")) !== null && _e !== void 0 ? _e : ""
            : "");
        if (searchId)
            scope.setTag("SearchId", searchId);
        if (idSession)
            scope.setTag("IdSession", idSession);
        if (extraTags) {
            for (const [k, v] of Object.entries(extraTags)) {
                if (k === "SearchId" || k === "IdSession")
                    continue;
                if (typeof v === "string" && v.length > 0) {
                    scope.setTag(k, v);
                }
            }
        }
        Sentry.captureMessage(message);
    });
}
